import React from "react"
import CKEditor from "@ckeditor/ckeditor5-react"
import BalloonEditor from "@ckeditor/ckeditor5-build-balloon"

class HTMLEditor extends React.Component {

	render() {
		let value = ''
		if(this.props.value) {
			value = this.props.value
		}
		return (
			<CKEditor
				editor={BalloonEditor}
				data={value}
				onInit={editor => {
					editor.setData(value)
				}}
				onChange={(event, editor) => {
					const data = editor.getData()
					this.props.onChange(this.props.name, data)
				}}
				onBlur={() => {
					this.props.onBlur(this.props.name, true)
				}}
			/>
		)
	}
}

export default HTMLEditor
